module.exports = __webpack_public_path__ + "static/img/qingdao1.8bc483bd.jpg";